import { useState } from "react";
import { testimonials } from "@/mocks/site/content";

export default function TestimonialsSection() {
  const [index, setIndex] = useState(0);
  const total = testimonials.length;
  const active = testimonials[index];

  const prev = () => setIndex((i) => (i - 1 + total) % total);
  const next = () => setIndex((i) => (i + 1) % total);

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div className="max-w-2xl">
            <div className="text-xs uppercase tracking-[0.18em] text-brand-600 font-bold mb-3">
              Customer Stories
            </div>
            <h4 className="font-display text-3xl md:text-5xl font-bold text-ink-900 leading-tight tracking-tight">
              <a href="#stories" className="text-ink-900 hover:text-ink-900 no-underline">
                Real people. Real moves. Real reviews.
              </a>
            </h4>
          </div>
          <div className="flex items-center gap-2 self-start md:self-end">
            <button
              onClick={prev}
              className="w-11 h-11 flex items-center justify-center rounded-md border border-ink-200 hover:bg-ink-900 hover:border-ink-900 hover:text-white text-ink-700 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-line"></i>
            </button>
            <button
              onClick={next}
              className="w-11 h-11 flex items-center justify-center rounded-md border border-ink-200 hover:bg-ink-900 hover:border-ink-900 hover:text-white text-ink-700 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        </div>

        <div id="stories" className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8">
          {/* Featured quote */}
          <div className="lg:col-span-7 bg-cream-50 rounded-2xl p-8 md:p-10 border border-ink-100">
            <div className="flex items-center gap-1 mb-6">
              {Array.from({ length: active.rating }).map((_, i) => (
                <i key={i} className="ri-star-fill text-amber-500 text-lg"></i>
              ))}
            </div>
            <i className="ri-double-quotes-l text-5xl text-brand-200 leading-none block mb-2"></i>
            <blockquote className="font-display text-xl md:text-2xl text-ink-900 leading-snug mb-8 -mt-2">
              {active.quote}
            </blockquote>
            <div className="flex items-center gap-4 pt-6 border-t border-ink-200">
              <img
                src={active.avatar}
                alt={active.name}
                className="w-14 h-14 rounded-full object-cover object-top"
              />
              <div>
                <div className="font-display font-bold text-ink-900">{active.name}</div>
                <div className="text-sm text-ink-500">{active.role}</div>
              </div>
              <div className="ml-auto text-[11px] font-semibold text-ink-400 tabular-nums">
                {String(index + 1).padStart(2, "0")} / {String(total).padStart(2, "0")}
              </div>
            </div>
          </div>

          {/* Small cards list */}
          <div className="lg:col-span-5 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-4">
            {testimonials.slice(0, 3).map((t, i) => {
              const realIndex = i;
              const isActive = realIndex === index;
              return (
                <button
                  key={t.id}
                  onClick={() => setIndex(realIndex)}
                  className={`text-left p-5 rounded-xl border transition-all cursor-pointer ${
                    isActive
                      ? "border-brand-500 bg-brand-50"
                      : "border-ink-100 bg-white hover:border-ink-300"
                  }`}
                >
                  <div className="flex items-center gap-3 mb-3">
                    <img
                      src={t.avatar}
                      alt={t.name}
                      className="w-10 h-10 rounded-full object-cover object-top"
                    />
                    <div className="flex-1 min-w-0">
                      <div className="font-semibold text-sm text-ink-900 truncate">{t.name}</div>
                      <div className="text-[11px] text-ink-500 truncate">{t.role}</div>
                    </div>
                    <div className="flex items-center gap-0.5">
                      <i className="ri-star-fill text-amber-500 text-xs"></i>
                      <span className="text-xs font-bold text-ink-700">{t.rating}.0</span>
                    </div>
                  </div>
                  <p className="text-xs text-ink-600 leading-relaxed line-clamp-3">{t.quote}</p>
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}